module.exports = __webpack_public_path__ + "static/media/Content1.88785cf3.pdf";